import type { TranslationCatalog } from "../TranslationManager";

export const id: TranslationCatalog = {
  "labels.cardNumber": "Nomor kartu",
  "labels.expirationDate": "Tanggal kedaluwarsa",
  "labels.cvc": "Kode keamanan",
  "placeholders.cardNumber": "1234 1234 1234 1234",
  "placeholders.expirationDate": "BB / TT",
  "placeholders.cvc": "CVV",
  "errors.invalidCardNumber": "Nomor kartu Anda tidak valid.",
  "errors.invalidExpiryDate": "Tanggal kedaluwarsa kartu Anda tidak valid.",
  "errors.invalidCvc": "Kode keamanan kartu Anda tidak valid.",
  "errors.incompleteCardNumber": "Nomor kartu Anda tidak lengkap.",
  "errors.incompleteExpiryDate": "Tanggal kedaluwarsa kartu Anda tidak lengkap.",
  "errors.incompleteCvc": "Kode keamanan kartu Anda tidak lengkap.",
  "errors.expiredCard": "Kartu Anda sudah kedaluwarsa.",
  "aria.cardNumber": "Nomor kartu",
  "aria.expirationDate": "Tanggal kedaluwarsa",
  "aria.cvc": "Kode keamanan",
  "aria.cardInput": "Informasi kartu",
};
